/** The minimum of a keyboard event the bell's row handler reads. */
export interface RowKeyEvent {
  key: string;
  target: unknown;
  currentTarget: unknown;
  preventDefault: () => void;
}

/**
 * Enter/Space on a header-bell row toggles the announcement — but only when
 * the row itself has focus. A key pressed on a control inside the row (the
 * card's "Open" button) belongs to that control: hijacking it would hide the
 * announcement instead of opening it (#436 review I2). Returns whether it toggled.
 */
export function handleRowToggleKey(e: RowKeyEvent, toggle: () => void): boolean {
  if (e.target !== e.currentTarget) return false;
  if (e.key !== "Enter" && e.key !== " ") return false;
  e.preventDefault();
  toggle();
  return true;
}
